import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { useAuth } from "../AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

async function login_func() {
  setLoading(true);
  setError("");

  let item = { email, password };

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    let response = await fetch(`${API_BASE_URL}/api/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(item),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);
    let result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Invalid login credentials");
    }
    login(result);
    navigate("/home");
  } catch (err) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
}

  return (
    <div className="login-form">
      <div className="container">
        <div className="row">
          <div className="patient-form">
            <h3>Login Here</h3>
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <br />
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <br />
            {error && <p style={{ color: "red" }}>{error}</p>}
           <button onClick={login_func} className="all" disabled={loading}>
  {loading ? "Logging in..." : "Login"}
</button>
          </div>
        </div>
      </div>
    </div>
  );
}
